// Mutation hook - przypisz zalogowanego handlowca do klienta
// POST /api/ui/sales-crm/clients/{id}/assign-trader-self

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseSuccess, ICommandResponseError as IError } from 'api/types';

const postAssignTraderToClient = (clientId: number): Promise<ICommandResponseSuccess> =>
  axios.post(`/sales-crm/clients/${clientId}/assign-trader-self`);

export const usePostAssignTraderToClient = (
  options?: UseMutationOptions<ICommandResponseSuccess, IError, number>
) =>
  useMutation<ICommandResponseSuccess, IError, number>(
    (clientId: number) => postAssignTraderToClient(clientId),
    options
  );
